// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__QhWjb","title":"ClientInsurance_title__B0M2J","itemText":"ClientInsurance_itemText__1FVZt"};